import Tag from "@/components/base/Tag";
import MicroLabel from "@/components/base/MicroLabel";

const outcomes: {
  name: string;
  behavior: string;
  price: string;
  note: string;
  delta: string;
  deltaNote: string;
  tone: "accent" | "primary";
}[] = [
  {
    name: "Market order",
    behavior: "Chases the price",
    price: "1.08457",
    note: "Lifted the ask and still paid up",
    delta: "−3.7 pips",
    deltaNote: "slippage",
    tone: "accent",
  },
  {
    name: "Limit order",
    behavior: "Names the price",
    price: "1.08400",
    note: "Waited for the market to come to it",
    delta: "0.0 pips",
    deltaNote: "no slippage",
    tone: "primary",
  },
];

export default function OutcomeCompare() {
  return (
    <div className="border-2 border-foreground-950 bg-background-50">
      <div className="flex items-center justify-between px-5 py-3 border-b-2 border-foreground-950 bg-primary-500">
        <MicroLabel>Same setup · different order</MicroLabel>
        <span className="flex items-center gap-1.5">
          <span className="w-2.5 h-2.5 bg-foreground-950"></span>
          <span className="w-2.5 h-2.5 bg-foreground-950/40"></span>
        </span>
      </div>

      <div className="px-5 py-4 border-b-2 border-foreground-950 flex flex-wrap items-center justify-between gap-x-4 gap-y-1">
        <MicroLabel tone="muted">The setup</MicroLabel>
        <span className="text-sm text-foreground-700">
          EUR/USD · watching{" "}
          <strong className="font-bold text-foreground-950">1.08420</strong>
        </span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2">
        {outcomes.map((outcome, index) => (
          <div
            key={outcome.name}
            className={`p-4 md:p-5 ${
              index === 0 ? "border-b-2 sm:border-b-0 sm:border-r-2 border-foreground-950" : ""
            }`}
          >
            <div className="flex items-center justify-between gap-2.5 border-b-2 border-foreground-950/15 pb-3">
              <h3 className="font-heading font-bold uppercase tracking-tight text-sm leading-none text-foreground-950">
                {outcome.name}
              </h3>
              <MicroLabel tone="muted">{outcome.behavior}</MicroLabel>
            </div>

            <div className="mt-5">
              <MicroLabel tone="muted">Filled at</MicroLabel>
            </div>
            <p className="mt-1 font-heading font-black text-2xl md:text-3xl leading-none tabular-nums text-foreground-950">
              {outcome.price}
            </p>
            <p className="mt-2 text-xs leading-relaxed text-foreground-600">{outcome.note}</p>

            <div className="mt-4">
              <Tag tone={outcome.tone}>
                {outcome.delta} · {outcome.deltaNote}
              </Tag>
            </div>
          </div>
        ))}
      </div>

      <div className="px-5 py-4 border-t-2 border-foreground-950 bg-background-100">
        <p className="text-xs md:text-sm leading-relaxed text-foreground-700">
          A <strong className="font-bold text-foreground-950">stop order</strong> works a third way.
          See it fire on the price path in the Visual guide further down.
        </p>
      </div>
    </div>
  );
}